import { useUnsavedChangesConfirmation } from '@cbridge-modules/unsaved-changes-confirmation';
import { useHasChanges, useHasChangesNow } from '../useHasChanges/useHasChanges';

export const UnsavedMessage = () => {
  const hasChanges = useHasChanges();
  const hasChangesNow = useHasChangesNow();
  useUnsavedChangesConfirmation(hasChanges, hasChangesNow);
  return null;
};
